<panel (mouseenter)="onMouseEnterPanel($event)" (mouseleave)="onMouseLeavePanel($event)">
    <div class="photo-item" style="position: relative;">
        <span class="photo-item__label">{{photo.Title}}</span>
        <img *ngIf="photo.Id != -1 && photo.Photo != ''" class="photo-item__image" [src]="getImage(photo.Photo)" (click)="openEditPhoto()" />
        <img *ngIf="newPhoto != null && newPhoto != ''" [src]="newPhoto" class="photo-item__image" />
        <div *ngIf="(photo.Id == -1 || photo.Photo == '') && (newPhoto == null || newPhoto == '')" class="upload-photo" (click)="fileInput.click()">
            <span>Upload Photo</span>
            <input style="display: none;" type="file"
                   #fileInput
                   (change)="onSelectPhoto($event)">
        </div>
        <div class="photo-item__label">
            {{photo.Description}}
            <span class="red" *ngIf="photo.Id == -1">Photo Required</span>
        </div>

        <div class="delete-photo" (click)="checkPermissionToDelete($event)" *ngIf="displayDeleteIcon" matTooltip="Remove Image">
            <i class="material-icons delete-photo__icon">clear</i>
        </div>
    </div>
</panel>
